import { Stack } from "@mui/material";
import React from "react";
import GlobalButton from "../CustomButton";
import LanguageMenu from "../LanguageMenu";
import { useNavigate } from "react-router-dom";

const LoginPart = () => {
  const naviagte = useNavigate();
  return (
    <Stack direction={"row"}>
      {/* <LanguageMenu /> */}
      <GlobalButton
        handleClickBtn={() => naviagte("/login")}
        btnText={"login"}
        styleProps={{
          display: { xs: "none", sm: "flex" },
          height: 45,
          width: 130,
          borderRadius: 1.5,
        }}
      />
    </Stack>
  );
};

export default LoginPart;
